import React from "react";
import { Drawer, Space, Button, Typography, Empty } from "antd";
import "./styles.css";
import { CloseOutlined } from "@ant-design/icons";
import { utilities } from "../../../utilities/utlities";
import {NotificationApis} from '../../Header/api'
import { useMutation } from "react-query";

const NotificationDrawer = (props) => {
  const { Title, Text } = Typography;
  const loggeUser = utilities.loggedUser()

  const mutation = useMutation(readNotification => {
    return NotificationApis.readUserNotification(readNotification.id,loggeUser?.jwtToken)
  })

  return (
    <Drawer
      maskClosable={false}
      className="notification-drawer"
      title={
        <div className="drawarTitle">
          <Title level={5}>Notifications</Title>
          <div>
            {props?.notifications?.length > 0 ? (
              <Button onClick={()=>{
                props.deleteNotification({id:[],type:'all'})
              }}>Clear All</Button>
            ) : null}
            <Button
              className="cancel_btn"
              onClick={() => {
                props.hidePop();
              }}
            >
              <CloseOutlined />
            </Button>
          </div>
        </div>
      }
      placement="right"
      width={390}
      size="default"
      closable={false}
      visible={props?.visible}
    >
      {props?.notifications?.length > 0 ? (
        props?.notifications?.map(item=>{
          return <div className="single-notification" onClick={()=>{
            if(!item?.hasOwnProperty("receiver")){
            mutation.mutateAsync({id:item?.quotationId})
            }
          }}>
            <>
              <Text className="title-notification-container">
                
                <span className="notification-title"><b>{item?.title}</b><br/> {item?.message} </span>
                <Button loading={props.loading && props.id == item?._id } className="delete-notification" onClick={(e)=>{
                  e.stopPropagation()
                  props.deleteNotification({id:[item?._id],type:'single'})
                }}>{props?.loading != true && props.id == '' ? 'X':''}</Button>
              </Text>
              <Text>{utilities.convertUTCDateToLocalDate(new Date(item?.createdAt))}</Text>
            </>
          </div>
        })
        
      ) : (
        <Empty className="no-notification" description="No Notification" />
      )}
    </Drawer>
  );
};

export default NotificationDrawer;
